export default __webpack_public_path__ + "static/IBMPlexSans-Text-Latin2-a6a940c87dcda0081eb37631e900fd01.woff";